import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector, createFeatureSelector } from '@ngrx/store';

import { customerAdapter } from './customer.reducer';
import { Customer } from '../../shared/models/shared.model';
import { CustomerModuleState } from '../models/customer.model';

const { selectAll } = customerAdapter.getSelectors();

export const getCustomerModuleState = createFeatureSelector<CustomerModuleState>('customerModule');

export const getCustomerState = createSelector(
  getCustomerModuleState,
  (state: CustomerModuleState) => state.customers,
);

export const getAllCustomers = createSelector(getCustomerState, selectAll);

export const getAllCustomersNameAndEmail = createSelector(getAllCustomers, (customers) =>
  customers.map((customer: Customer) => ({
    id: customer.id,
    name: `${customer.name} (${customer.emailAddress})`,
  })),
);

export const getSelectedCustomer = createSelector(
  getCustomerModuleState,
  (state) => state.selectedCustomer,
);

export const getSelectedCustomerId = createSelector(
  RouterSelectors.getRouteParam('customerId'),
  (customerId) => (customerId ? Number.parseInt(customerId, 10) : undefined),
);

export const selectLoadingCustomers = createSelector(
  getCustomerModuleState,
  (state) => state.loadingCustomers,
);

export const getLocationsForCustomer = createSelector(getSelectedCustomer, (customer: Customer) =>
  customer ? customer.locations : [],
);

export const getSelectedLocationId = createSelector(
  RouterSelectors.getRouteParam('locationId'),
  (locationId) => (locationId ? Number.parseInt(locationId, 10) : undefined),
);

export const getSelectedLocation = createSelector(
  getSelectedCustomer,
  getSelectedLocationId,
  (customer: Customer, locationId: number) =>
    !!customer && !!customer.locations && customer.locations.find((l) => l.id === locationId),
);

export const getSearchText = createSelector(getCustomerModuleState, (state) => state.searchText);
